import api from '@api'
import {
  buildRelationalQualificationStructure,
  buildFlatQualificationStructure,
} from '@data/qualification'
import { isPortalLogin } from '@utils/auth'

export function transformCsvBatchForList(data) {
  return {
    batchNumber: data.name,
    id: data.id,
    status: data.status,
    createdTime: data.createdTime,
    totalCount: data.totalCount,
    successRecordCount: data.successRecordCount,
    failedRecordCount: data.failedRecordCount,
    endTime: data.endTime,
    createdBy: data.createdById,
    discoveryType: data.discoveryType,
    ipRangeType: data.ipRangeType,
    cloudType: data.cloudType,
    privateCloudType: data.privateCloudType,
    message: data.message,
    processingTime: data.endTime > 0 ? data.endTime - data.startTime : 0,
    importFileType: data.importFileType,
    moduleName: data.model,
  }
}

export function transformCsvBatch(data) {
  return {
    batchNumber: data.name,
    batchId: data.id,
    status: data.status,
    createdBy: data.createdById,
    createdTime: data.createdTime,
    startTime: data.startTime,
    endTime: data.endTime,
    totalCount: data.totalCount,
    successRecordCount: data.successRecordCount,
    failedRecordCount: data.failedRecordCount,
    message: data.message,
    importFileType: data.importFileType,
    moduleName: data.model,
  }
}

export function getCsvBatchApi(batchId) {
  return api.get(`/batch/${batchId}`).then(transformCsvBatch)
}

export function getCsvBatchesApi(moduleName, filter, limit, offset) {
  return api
    .post(
      `${isPortalLogin() ? '/cportal' : ''}/${moduleName}/batch/search/byqual`,
      {
        ...(moduleName === 'user'
          ? {
              qualDetails: buildFlatQualificationStructure([
                buildRelationalQualificationStructure(
                  'user.userType',
                  'equal',
                  filter.userType,
                  'enum'
                ),
              ]),
            }
          : {}),
        ...(moduleName === 'category'
          ? {
              qualDetails: buildFlatQualificationStructure([
                buildRelationalQualificationStructure(
                  'categoryParentModel',
                  'equal',
                  filter.userType,
                  'enum',
                  'db'
                ),
              ]),
            }
          : {}),
        ...(moduleName === 'task'
          ? {
              qualDetails: buildFlatQualificationStructure([
                buildRelationalQualificationStructure(
                  'projectId',
                  'equal',
                  filter.projectId,
                  'long',
                  'db'
                ),
              ]),
            }
          : {}),
      },
      {
        params: {
          size: limit,
          offset: offset,
        },
        notify: false,
      }
    )
    .then((data) => {
      return {
        items: (data.objectList || []).map(transformCsvBatchForList),
        total: data.totalCount,
      }
    })
}
